import React from 'react';
import './Details.css';
import { Link } from 'react-router-dom';

const Details = ({ details }) => {
  return (
    <section className="card details-card">
      <h2>Jump, bounce, slide</h2>
      <p className="intro-text">
        Pull on your socks and join us for an afternoon on the inflatables as Advait bounces into {details.age}.
      </p>

      <dl className="detail-list">
        <div className="detail-row">
          <dt>When</dt>
          <dd>
            {details.date}<br />
            {details.time}
          </dd>
        </div>
        <div className="detail-row">
          <dt>Where</dt>
          <dd>
            {details.locationName}<br />
            {details.locationAddress}<br />
            {details.locationPhone}
          </dd>
        </div>
      </dl>

      <a
        href="https://maps.google.com/?q=Pump+It+Up+2919+Mead+Ave+Santa+Clara+CA+95051"
        target="_blank"
        rel="noopener noreferrer"
        className="map-link"
      >
        Get directions
      </a>

      <p className="sock-note">
        🧦 Socks are required to play, so bring a pair for every jumper. Please arrive 15 minutes early to sign the waiver.
      </p>

      <div className="rsvp-section-in-details">
        <p>Please RSVP by <strong>{details.rsvpDate}</strong>.</p>
        <Link to="/rsvp" className="rsvp-button">RSVP for the party</Link>
      </div>
    </section>
  );
};

export default Details;
